/**
 * <cl-chips-slider> — one-line Swiper slider for the collection subcategory chips.
 *
 * Free-mode, auto-width slides: drag with the mouse, swipe on touch. The row starts with the
 * current subcategory's chip centred. A custom element (not a one-off init)
 * because the chips live inside #ProductGridContainer, which facets.js re-renders on every
 * filter change — each new element initialises itself and the old one cleans up.
 */
if (!customElements.get('cl-chips-slider')) {
  customElements.define(
    'cl-chips-slider',
    class ClChipsSlider extends HTMLElement {
      connectedCallback() {
        if (this.swiper || typeof Swiper === 'undefined') return;

        const slides = Array.from(this.querySelectorAll('.swiper-slide'));
        const activeIndex = slides.findIndex((slide) => slide.querySelector('[aria-current]'));

        this.swiper = new Swiper(this, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          freeMode: { enabled: true, momentum: true },
          grabCursor: true,
          watchOverflow: true,
          breakpoints: {
            750: { spaceBetween: 14 },
          },
        });

        if (activeIndex > 0) this.reveal(slides[activeIndex], 0);
      }

      // Centre the chip in the row; translateTo clamps at either end so the row never overshoots
      reveal(chip, speed = 300) {
        const slide = chip.closest('.swiper-slide');
        if (!this.swiper || !slide || this.swiper.isLocked) return;

        const row = this.getBoundingClientRect();
        const rect = slide.getBoundingClientRect();
        const delta = rect.left + rect.width / 2 - (row.left + row.width / 2);
        if (Math.abs(delta) > 1) this.swiper.translateTo(this.swiper.translate - delta, speed);
      }

      disconnectedCallback() {
        // facets.js moves the subcategory tabs row back in right after a re-render; only tear
        // down when the element is really gone, so the row keeps its scroll position
        queueMicrotask(() => {
          if (this.isConnected || !this.swiper) return;
          this.swiper.destroy(true, true);
          this.swiper = null;
        });
      }
    }
  );
}
